module.exports = __webpack_public_path__ + "static/img/bgs4.e6f0ae9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/bgs4.jpg
// module id = 7F++
// module chunks = 1